<template>
  <div class="invite">
    <div class="logo">
      <img
        class="logo-img"
        src="@/assets/img/logo_landing.png"
        srcset="@/assets/img/logo_landing@2x.png 2x, @/assets/img/logo_landing@3x.png 3x"
        alt="听语logo">
    </div>
    <div class="desc"></div>
    <div class="red-packet" @click="openDia">
      <div v-if="haveGet" class="con-get"></div>
      <img
        class="card"
        src="@/assets/img/pic_card@2x.png"
        srcset="@/assets/img/pic_card@2x.png 2x, @/assets/img/pic_card@3x.png 3x"
        alt="卡片">
      <transition
        leave-active-class="animate__animated animate__fadeOut">
        <img
          v-if="!haveGet"
          class="firework"
          src="@/assets/img/pic_tic@2x.png"
          srcset="@/assets/img/pic_tic@2x.png 2x, @/assets/img/pic_tic@3x.png 3x"
          alt="礼花">
      </transition>
      <transition
        leave-active-class="animate__animated animate__fadeOut">
        <img
          v-if="!haveGet"
          class="light"
          src="@/assets/img/pic_light@2x.png"
          srcset="@/assets/img/pic_light@2x.png 2x, @/assets/img/pic_light@3x.png 3x"
          alt="光芒">
      </transition>
      <transition
        leave-active-class="animate__animated animate__fadeOutDown"
        @after-leave="animateLeave">
        <img
          v-if="!haveGet"
          class="redbg-front"
          src="@/assets/img/redbg_front@2x.png"
          srcset="@/assets/img/redbg_front@2x.png 2x, @/assets/img/redbg_front@3x.png 3x"
          alt="红包前">
      </transition>
      <transition
        leave-active-class="animate__animated animate__fadeOutDown">
        <img
          v-if="!haveGet"
          class="redbg-behind"
          src="@/assets/img/redbg_behind@2x.png"
          srcset="@/assets/img/redbg_behind@2x.png 2x, @/assets/img/redbg_behind@3x.png 3x"
          alt="红包后">
      </transition>
      <transition
        enter-active-class="animate__animated animate__fadeIn">
        <div v-if="animateEnd" class="redbg-btn" @click="gotoDownload"></div>
      </transition>
    </div>
    <!-- <div class="tip">
      <div class="left">提示：</div>
      <div class="right">注册成功的新用户立即赠送1个月VIP会员，须在有效 期内登录使用会员权益，过期失效</div>
    </div> -->
    <transition>
      <div v-show="showDialog" class="dialog">
        <div class="dialog-model"></div>
        <div class="dialog-wrapper">
          <div class="register">
            <vant-field
              class="tel-input"
              v-model="telephone"
              @click="inpFocus"
              placeholder="请输入手机号"
              type="tel"></vant-field>
            <div class="df">
              <vant-field
                class="code-input"
                v-model="smsCode"
                @click="inpFocus"
                placeholder="请输入验证码"
                type="digit"></vant-field>
              <div
                @click="sendCode"
                :class="btnDisable ? 'disabled': ''"
                class="code-btn">{{btnDisable ? `${count}s后重新获取` : message}}</div>
              <div
                id="validatBtn"
                style="display: none;"
              ></div>
            </div>
            <vant-button
              @click="submit"
              :disabled="!(!!telephone && !!smsCode)">立即注册</vant-button>
            <!-- <div
              @click="submit"
              @touchstart="submitPressed = true"
              @touchend="submitPressed = false"
              :class="submitPressed ? 'pressed' : ''"
              class="submit-btn">免费领取一个月VIP会员</div> -->
          </div>
        </div>
        <div class="close" @click="showDialog = false"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import isIOS from '@/util/isIOS.js'
import {
  Field as VantField,
  // Form as VantForm,
  Toast,
  Button as VantButton
} from 'vant'

import { getLocal, setLocal, delLocal } from '@/util/storage'
export default {
  name: 'NewHome',
  components: {
    VantField,
    VantButton
    // VantForm
  },
  data () {
    return {
      telephone: '',
      message: '获取验证码',
      smsCode: '',
      // false代表可以点击
      btnDisable: false,
      // 验证码倒计时
      count: 0,
      // 定时器id
      timer: null,
      // 提交按钮是否被按下
      submitPressed: false,
      // 腾讯防水墙实例
      tencentInstance: null,
      showDialog: false,
      // 是否已领取
      haveGet: false,
      animateEnd: false
    }
  },
  // watch: {
  //   showDialog (val) {
  //     if (!val) {
  //       this.toggleHaveGet()
  //     }
  //   }
  // },
  // 修改软键盘弹出，导致布局上移
  mounted () {
    const time = Number(getLocal('codeTimer')) || 0
    if (time > 0) {
      const TIME_COUNT = 60 - Math.ceil((new Date().getTime() - time) / 1000)
      // 如果时间已经超出一分钟，就删除这个本地存储
      if (TIME_COUNT > 60 || TIME_COUNT < 0) {
        delLocal('codeTimer')
      } else {
        this.setTimer(TIME_COUNT, 'mounted')
      }
    }
    this.tencentInstance = new window.TencentCaptcha(
      document.getElementById('validatBtn'),
      '2084882807',
      async res => {
        // 防水墙弹出后
        if (res.ret === 0) {
          this.$axios.post('/lc/visitor/sendCode', {
            phone: this.telephone,
            ticket: res.ticket,
            randStr: res.randstr
          }).then(res2 => {
            Toast('验证码发送成功')
            this.getCode()
          })
        }
      }
    )
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    inpFocus () {
      setTimeout(() => {
        if (window.scrollY !== 0) {
          window.scrollTo(0, 0)
        }
      }, 300)
    },
    animateLeave () {
      this.animateEnd = true
    },
    toggleHaveGet () {
      this.haveGet = true
    },
    openDia () {
      if (!this.haveGet) {
        this.showDialog = true
      }
    },
    // 设置定时器
    getCode () {
      const TIME_COUNT = 60
      this.setTimer(TIME_COUNT, 'hand')
    },
    /**
     * @desc  每次点击按钮的时候，将此时的时间戳存在本地存储中，用户刷新后，取出来对比，刷新后重新挂载的时候，这次设置定时器不需要将此时的时间戳存起来
     * @param TIME_COUNT
     * @param type
     */
    setTimer (TIME_COUNT, type) {
      if (!this.timer) {
        // 倒计时事件
        this.count = TIME_COUNT
        this.btnDisable = true
        if (type === 'hand') {
          setLocal('codeTimer', new Date().getTime())
        }
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            clearInterval(this.timer)
            this.btnDisable = false
            this.timer = null
          }
        }, 1000)
      }
    },
    /**
     * 校验
     * @param val {string} [需要校验的值]
     * @param valid {Reg}    [校验的正则]
     */
    valida (val, valid) {
      return new Promise((resolve, reject) => {
        resolve(valid.test(val))
      })
    },
    // 校验6位验证码
    validaSmsCode (val) {
      return /^d{6}$/.test(val)
    },
    // 发送短信验证码
    sendCode () {
      // 如果现在按钮正在倒计时，点击按钮不做处理
      if (this.btnDisable) return
      // 发送短信验证码之前先校验手机号
      this.valida(this.telephone, /^1\d{10}$/)
        .then(valid => {
          if (valid) {
            // 发送验证码
            this.tencentInstance.show()
          } else {
            Toast('请输入正确格式的手机号码')
          }
        })
    },
    submit () {
      this.valida(this.telephone, /^1\d{10}$/)
        .then(valid => {
          if (valid) {
          // 校验验证码
            return this.valida(this.smsCode, /^\d{6}$/)
          } else {
            const message = '请输入正确格式的手机号码'
            Toast(message)
            return Promise.reject(new Error(message))
          }
        }).then(valid => {
          if (valid) {
            // 发送提交请求
            const uid = this.$route.query.uid
            const param = {
              phone: this.telephone,
              smsCode: this.smsCode
            }
            if (uid) {
              param.uid = uid
            }
            try {
              this.$axios.post('/lc/visitor/invitation', param).then(res => {
                if (res.data.isNew) {
                  // this.$router.push('/success')
                  this.showDialog = false
                  this.toggleHaveGet()
                } else {
                  this.$router.push('/notNewUser')
                }
              })
            } catch (e) {
              console.error(e)
            }
          } else {
            Toast('请输入正确的6位验证码')
          }
        }).catch(e => {
          console.error(e.message)
        })
    },
    gotoDownload () {
      if (isIOS()) {
        window.location.href = 'itms-apps://itunes.apple.com/cn/app/jie-zou-da-shi/id1525482365?mt=8'
      } else {
        // this.$router.push('/download')
        this.$router.push({ path: '/download', query: { type: 'speech' } })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@media only screen and (-webkit-min-device-pixel-ratio:2) {
  .invite {
    background-image: url(~@/assets/img/bg_landing@2x.png) !important;
  }
  .redbg-btn {
    background-image: url(~@/assets/img/btn_download@2x.png) !important;
  }
  .con-get {
    background-image: url(~@/assets/img/pic_cong@2x.png) !important;
  }
  .desc {
    display: none !important;
  }
}
@media only screen and (-webkit-min-device-pixel-ratio:3) {
  .invite {
    background-image: url(~@/assets/img/bg_landing@3x.png) !important;
  }
  .redbg-btn {
    background-image: url(~@/assets/img/btn_download@3x.png) !important;
  }
  .con-get {
    background-image: url(~@/assets/img/pic_cong@3x.png) !important;
  }
  .desc {
    display: none !important;
  }
}
@mixin imgFix {
  position: absolute;
  left: 50%;
  // transform: translateX(-50%);
}
.invite {
  position: relative;
  height: 100vh;
  min-height: 1200px;
  padding-top: 340px;
  background-size: 100%;
  background-color: #d2b2ff;
  background-repeat: no-repeat;
  background-image: url(~@/assets/img/bg_landing.png);
  .logo {
    position: absolute;
    top: 33px;
    left: 40px;
    width: 240px;
    height: 70px;
    img {
      width: 240px;
      height: 70px;
    }
  }
  .desc {
    position: absolute;
    width: 586px;
    height: 220px;
    left: 50%;
    top: 140px;
    transform: translateX(-293px);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url(~@/assets/img/bg_title.png);
  }
  .tip {
    display: flex;
    position: absolute;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    width: 686px;
    height: 106px;
    line-height: 43px;
    padding: 10px 30px;
    background-color: rgba(255, 255, 255, .46);
    border-radius: 12px;
    color: #5B8BE4;
    .left {
      flex: 2;
      font-size: 24px;
    }
    .right {
      flex: 15;
      font-size: 24px;
      text-align: left;
    }
  }
  .red-packet {
    position: relative;
    height: 700px;
    padding-top: 60px;
    .card {
      @include imgFix;
      width: 515px;
      height: 400px;
      top: 60px;
      margin-left: -258px;
      z-index: 3;
    }
    .firework {
      @include imgFix;
      width: 750px;
      height: 288px;
      top: 140px;
      margin-left: -375px;
      z-index: 2;
    }
    .light {
      @include imgFix;
      width: 750px;
      height: 591px;
      top: 60px;
      margin-left: -375px;
      z-index: 2;
    }
    .redbg-front {
      @include imgFix;
      width: 564px;
      height: 288px;
      top: 370px;
      margin-left: -282px;
      z-index: 5;
    }
    .redbg-behind {
      @include imgFix;
      width: 564px;
      height: 340px;
      top: 330px;
      margin-left: -282px;
      z-index: 1;
    }
    .redbg-btn {
      @include imgFix;
      width: 610px;
      height: 130px;
      top: 520px;
      margin-left: -305px;
      background-size: 100% 100%;
      background-image: url(~@/assets/img/btn_download@2x.png);
      z-index: 1;
    }
    .con-get {
      @include imgFix;
      width: 382px;
      height: 50px;
      top: 0px;
      margin-left: -196px;
      background-size: 100% 100%;
      background-image: url(~@/assets/img/pic_cong@2x.png);
      z-index: 1;
    }
  }
  .dialog {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 10;
    .dialog-model {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, .6);
    }
    .dialog-wrapper {
      position: absolute;
      top: 172px;
      left: 50%;
      transform: translateX(-50%);
      width: 570px;
      height: 626px;
      z-index: 12;
      background-image: url(~@/assets/img/bg_pop@2x.png);
      background-size: 100% 100%;
      .register {
        position: absolute;
        width: 500px;
        top: 206px;
        left: 35px;
        // padding: 206px 35px 0;
      }
      .df {
        display: flex;
        margin-bottom: 72px;
        .van-field {
          flex: 11;
          border-radius: 12px 0 0 12px;
        }
        .code-btn {
          text-align: center;
          line-height: 80px;
          font-size: 28px;
          color: #fff;
          flex: 9;
          border-radius: 0 12px 12px 0;
          background-color: #3b9afc;
        }
        .disabled {
          background-color:  #ddd;
          color: #999;
        }
      }
      .van-field {
        width: 100%;
        height: 80px;
        // padding-left: 44px;
        // padding-right: 44px;
        border-radius: 12px;
        border: 2px solid rgba(221, 221, 221, 1);
        // margin: 0 auto 32px;
        &.tel-input {
          margin-bottom: 32px;
        }
        & ::v-deep .van-field__body,
        & ::v-deep .van-field__body input {
          font-size: 28px;
          height: 100%;
          line-height: 1;
        }
      }
      .van-button {
        // vant默认为inline-flex,兼容safari
        display: block;
        width: 100%;
        height: 80px;
        background-color: #3B9AFC;
        text-align: center;
        color: #fff;
        &.van-button--disabled {
          background-color: #ddd;
        }
        & ::v-deep .van-button__text {
          font-size: 34px;
        }
      }
    }
    .close {
      position: absolute;
      top: 834px;
      left: 50%;
      transform: translateX(-50%);
      width: 96px;
      height: 96px;
      z-index: 12;
      background-image: url(~@/assets/img/icon_pop_close@2x.png);
      background-size: 100% 100%;
    }
  }
}
</style>
